<ndt-register-view
   [name]="name"
   [totalCount]="totalCount"
   [callState]="callState"
   [hasNextPage]="hasNextPage"
   [pagingCallState]="pagingCallState"
   [searchText]="searchText"
   [showCreate]="locationPrivileges?.canAdd"
   (create)="onCreate()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
>
   <lcs-responsive-table [columns]="columns">
      <table lcs-table [dataSource]="dataSource">
         <tr lcs-header-row *lcsResponsiveHeaderRowDef></tr>
         <tr lcs-row *lcsResponsiveRowDef></tr>
         <ng-container lcsColumnDef="address" width="5">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="locationsAddress-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'houseNumber')"
               sortField="houseNumber"
               >Address
               <mat-icon class="mat-icon-sort">{{ getSort('houseNumber') }}</mat-icon>
            </th>
            <td lcs-cell *lcsCellDef="let locations">
               <a [routerLink]="getRouterLink(locations.locationId)">
                  {{ locations.address }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="name" width="5">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="locationsAddress-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'name')"
               sortField="name"
               >Name
               <mat-icon class="mat-icon-sort">{{ getSort('name') }}</mat-icon>
            </th>
            <td lcs-cell *lcsCellDef="let locations">
               <a [routerLink]="getRouterLink(locations.locationId)">
                  {{ locations.name }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="city" width="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="locationsCity-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'city')"
               sortField="city"
               >City
               <mat-icon class="mat-icon-sort">{{ getSort('city') }}</mat-icon>
            </th>
            <td lcs-cell *lcsCellDef="let locations">
               <a [routerLink]="getRouterLink(locations.locationId)">
                  {{ locations.city | addSpaces }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="state" width="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="locationsState-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'state')"
               sortField="state"
               >State
               <mat-icon class="mat-icon-sort">{{ getSort('state') }}</mat-icon>
            </th>
            <td lcs-cell *lcsCellDef="let locations">
               <a [routerLink]="getRouterLink(locations.locationId)">
                  {{ locations.state | addSpaces }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="zipcode" width="4">
            <th
               class="register-column-header"
               lcs-header-cell
               *lcsHeaderCellDef
               id="locationsZipCode-column-header"
               ndtSortColumn
               (emitter)="onOrderingOptionsChange($event)"
               [sortDirection]="getOrderingOption(orderingOptions, 'postalCode')"
               sortField="postalCode"
               >Postal Code
               <mat-icon class="mat-icon-sort">{{ getSort('postalCode') }}</mat-icon>
            </th>
            <td lcs-cell *lcsCellDef="let locations">
               <a [routerLink]="getRouterLink(locations.locationId)">
                  {{ locations.postalCode }}
               </a>
            </td>
         </ng-container>
         <ng-container lcsColumnDef="locationActionsMenu" width="1">
            <th lcs-header-cell *lcsHeaderCellDef id="locations-actions-menu-column-header"></th>
            <td lcs-cell *lcsCellDef="let locations">
               <button
                  type="button"
                  aria-label="Locations Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="locationsRolesMenu"
                  id="extension-group-more-actions"
               >
                  <mat-icon> more_horiz </mat-icon>
               </button>
               <mat-menu #locationsRolesMenu="matMenu">
                  <a mat-menu-item [routerLink]="getRouterLink(locations.locationId)"> Details </a>
               </mat-menu>
            </td>
         </ng-container>
      </table>
   </lcs-responsive-table>
</ndt-register-view>
